import { render, staticRenderFns } from "./letterLayout.vue?vue&type=template&id=17ff7900&scoped=true"
import script from "./letterLayout.vue?vue&type=script&lang=js"
export * from "./letterLayout.vue?vue&type=script&lang=js"
import style0 from "./letterLayout.vue?vue&type=style&index=0&id=17ff7900&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff7900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ff7900')) {
      api.createRecord('17ff7900', component.options)
    } else {
      api.reload('17ff7900', component.options)
    }
    module.hot.accept("./letterLayout.vue?vue&type=template&id=17ff7900&scoped=true", function () {
      api.rerender('17ff7900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/we/letterLayout.vue"
export default component.exports